export default "__VITE_ASSET__8d812d4b__"